export default __webpack_public_path__ + "static/media/landingBg2.d0baef28.png";